import React from 'react';
import { useDispatch } from 'react-redux';
import { removeModal } from 'Redux/modules/modal/actions';
import { Button, Modal } from 'semantic-ui-react';
import css from './AlreadyHaveConsult.less';

const AlreadyHaveConsult = ({ data, id }) => {
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(removeModal(id));
  };
  return (
    <div className={css.container}>
      <Modal
        onClose={onClose}
        open
        closeIcon
        className={css.customModal}
        size="small"
      >
        <Modal.Header>Ongoing Teleconsult </Modal.Header>
        <Modal.Content className={css.modalContent}>
          You're currently having a consultation with this patient. Would you like to continue with the existing conversations?
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              onClose();
            }}
            className={css.submitBtn}
          >
            Later
          </Button>
          <Button
            primary
            onClick={() => {
              data?.onConfirmAction();
              onClose();
            }}
            className={css.submitBtn}
          >
            Yes, I'd like to
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default AlreadyHaveConsult;
